import React from 'react'
import styled from 'styled-components'
import SuccessIcon from '../../assets/icons/JSX/CircleCheckmarkIcon'
import ErrorIcon from '../../assets/icons/JSX/CircleCloseRedIcon'
import InfoIcon from '../../assets/icons/JSX/InfoIcon'
import Colors from '../../assets/styles/Colors'
//
//
const InfoMessage: React.FC<{
  variant: 'info' | 'success' | 'error'
  title?: string
  text?: string
  background?: 'gray' | 'light-red' | 'none'
  style?: React.CSSProperties
}> = ({ variant = 'info', title, text, background = 'none', style }) => {
  //
  //
  return (
    <Wrapper $background={background} style={style}>
      <IconBlock>
        {variant === 'info' && <InfoIcon />}
        {variant === 'success' && <SuccessIcon />}
        {variant === 'error' && <ErrorIcon />}
        {/*  */}
        <span>{title}</span>
      </IconBlock>
      <div className="rich-text-div">{text}</div>
    </Wrapper>
  )
}
//
const IconBlock = styled.div`
  display: flex;
  align-items: flex-start;
  /*  */
  span {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: ${Colors.primaryBlack};
    margin-bottom: 10px;
  }
  /*  */
  svg {
    width: 20px;
    height: 20px;
    margin-right: 16px;
    object-fit: contain;
    margin-top: 4px;
  }

  /*  */
`
const Wrapper = styled.div<{ $background: 'gray' | 'light-red' | 'none' }>`
  width: 100%;
  padding: ${({ $background }) => ($background === 'none' ? '0px' : '14px')};
  border-radius: 4px;
  background-color: ${({ $background }) =>
    $background === 'gray' ? Colors.grey : $background === 'light-red' ? Colors.lightRed : 'transparent'};

  .rich-text-div {
    font-size: 13px !important;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${Colors.nevadaGrey};
    margin-left: 36px;
  }
`
//
export default InfoMessage
